module.exports = __webpack_public_path__ + "static/media/fight.4fe7478f.mp3";